import _adminBookCall from './admin-book-call.png';
import _errorState from './error-state.svg';
import _frame29 from './frame-29.png';
import { getSrc } from './utils';

export const errorState = getSrc(_errorState);
export const frame29 = getSrc(_frame29);
export const adminBookCall = getSrc(_adminBookCall);
